import React, { useState, useEffect } from "react";
// utils
import FormButton from "../../button/FormButton";
import CommonForm from "../CommonForm";
import { FormikTextInput } from "../../inputs/FormikInputs";
import Mapa from './Mapa';
// functions
import { postZone, deleteZone, updateZone } from './ZonasDeNoEnrollFunctions';
import { handleResponse } from "../../../../services/Local-services";
// validaciones
import { formikValidation } from './ZonasDeNoEnrollFormValidaciones';
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { userCredentials, formIsOpen, rowSelected, snackbarData, formData } from '../../../../recoilState/GlobalState'; 

export default function ZonaDeNoEnrollForm(props) {
    const [newZone, setNewZone] = useState({});
    const [inRequest, setInRequest] = useState(false);

    const setIsOpen = useSetRecoilState(formIsOpen);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const [selected, setSelected] = useRecoilState(rowSelected);
    const credentials = useRecoilValue(userCredentials);
    const data = useRecoilValue(formData);

    const { titles, updateList, procede } = props.props;

    async function handleAction() {
        const functions = { setSnackbarInfo, setInRequest, setIsOpen, setSelected, updateList };
        if (procede === 'Deleteone') {
            const response = await deleteZone(credentials, selected.row, setInRequest);
            return handleResponse(response, 'Zona de no enroll eliminada exitosamente', functions);
        }
        if (procede === 'Addone') {
            const response = await postZone(credentials, newZone, setInRequest)
            return handleResponse(response, 'Zona de no enroll añadida exitosamente', functions);
        }
        if (procede === 'Editone') {
            const response = await updateZone(credentials, newZone, selected.row, setInRequest)
            return handleResponse(response, 'Zona de no enroll modificada exitosamente', functions);
        }
    };

    useEffect(() => {
        if (procede !== 'Deleteone') handleAction();
    }, [newZone])

    const formik = formikValidation(setNewZone, selected.row, titles);
    const disabled = inRequest || procede === 'Deleteone';

    return (
        <CommonForm
            onSubmit={formik.handleSubmit}
            title={data.title}
            procede={procede}
        >
            <FormikTextInput
                data={data}
                name="nombre"
                formik={formik}
                disabled={disabled}
            />
            <Mapa
                value={formik.values.coordenadas}
                onChange={formik.handleChange}
            />
            <FormButton
                inRequest={inRequest}
                handleAction={handleAction}
            />
        </CommonForm>
    );
};